export const lightTheme = {
  colors: {
    white: '#fff',
    lightText: '#999',
    default: '#000'
  },
  body: {
    background: '#f1f4fb',
    color: '#313131',
    subTitleColor: '#777777'
  },
  header: {
    size: '80px',
    padding: '12px',
    background: '#fff',
    boxShadow: '#4466f221'
  },
  sidebar: {
    background: '#2f3c4e',
    color: '#000000'
  },
  form: {
    border: '#ced4da',
    text: '#000'
  }
}

export const darkTheme = {
  colors: {
    white: '#fff',
    lightText: '#999',
    default: '#fff'
  },
  body: {
    background: '#293240',
    color: '#ffffffd9'
  },
  header: {
    size: '80px',
    padding: '12px',
    background: '#2f3c4e',
    boxShadow: '#4466f221'
  },
  sidebar: {
    background: '#2f3c4e',
    color: '#fbfbfb'
  },
  form: {
    border: '#374558',
    text: '#cccccc'
  }
}
